export default __webpack_public_path__ + "static/media/red1.7a3cfc63.svg";